var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('catalog-product-list',{attrs:{"data-source":_vm.dataSource,"wishlist-items":_vm.wishlistItems,"chunk-size":_vm.chunkSize}}),_vm._v(" "),(_vm.showCompare)?_c('catalog-product-compare'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }